/**
 * <s-scroll-top> makes the page it sits on always open at the very top,
 * instead of the browser restoring an earlier scroll position.
 * Links that target a specific spot (a #hash) are left alone.
 */
class SScrollTop extends HTMLElement {
  connectedCallback() {
    if (window.location.hash) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    toTop();
    requestAnimationFrame(toTop);
    this.onPageShow = () => toTop();
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onPageShow);
  }
}

if (!customElements.get('s-scroll-top')) {
  customElements.define('s-scroll-top', SScrollTop);
}
